import React from 'react'
import styled from '@emotion/styled'
import { radius } from '@mobi/component-library/Foundations'
import { AFLTeamIcon } from './AFLTeamIcon'
import { NRLTeamIcon } from './NRLTeamIcon'

export const TeamIcon: React.FC<{
  size: string
  defaultIcon: React.ReactNode
  leagueId?: number | null
  participationId?: number | null
}> = ({ size, defaultIcon, leagueId, participationId }) => {
  if (!participationId || !leagueId) {
    return defaultIcon
  }

  const leagueTeamIcon = getLeagueTeamIcon({ leagueId })
  if (!leagueTeamIcon) {
    return defaultIcon
  }

  const icon = leagueTeamIcon({ participationId })
  if (!icon) return defaultIcon

  return (
    <StyledDiv
      style={{
        width: size,
        height: size,
      }}
    >
      {icon}
    </StyledDiv>
  )
}

// ================
// Styles
// ================

const StyledDiv = styled.div({
  display: 'inline-flex',
  borderRadius: radius.md,
  border: '0.2rem solid #fff',
  overflow: 'hidden',

  '> img': {
    maxWidth: '100%',
    width: '100%',
    height: 'auto',
  },
})

// ================
// Local Constants
// ================

const enum LocalConstants {
  WnrlLeagueId = 2000117032,
  NrlLeagueId = 2000050687,
  WaflLeagueId = 2000097953,
  AflLeagueId = 1000470474,
}

// ===============
// Local Component
// ===============

const getLeagueTeamIcon = ({ leagueId }: { leagueId: number }) => {
  switch (leagueId) {
    case LocalConstants.WnrlLeagueId:
    case LocalConstants.NrlLeagueId:
      return NRLTeamIcon
    case LocalConstants.WaflLeagueId:
    case LocalConstants.AflLeagueId:
      return AFLTeamIcon
    default:
      return null
  }
}
